import { render, staticRenderFns } from "./ModalRedirecionarFolha.vue?vue&type=template&id=3664cd14&scoped=true"
import script from "./ModalRedirecionarFolha.vue?vue&type=script&lang=js"
export * from "./ModalRedirecionarFolha.vue?vue&type=script&lang=js"
import style0 from "./ModalRedirecionarFolha.vue?vue&type=style&index=0&id=3664cd14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3664cd14",
  null
  
)

export default component.exports